// extracted by mini-css-extract-plugin
export default {"title":"Reviews_title__GK36G","imgWrapper":"Reviews_imgWrapper__FXGXD"};